/* tslint:disable */

/**
 */
export class SaveAsEquipment {
    nameEquipment?: string;
    versionEquipment?: number;
    equipmentId?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/save-as-equipment.ts